import request from '@/utils/request'


// 查询平台文章列表
export function listArticle(query) {
  return request({
    url: '/platform/article/list',
    method: 'get',
    params: query
  })
}

// 查询平台文章分页
export function pageArticle(query) {
  return request({
    url: '/platform/article/page',
    method: 'get',
    params: query
  })
}

// 查询平台文章详细
export function getArticle(data) {
  return request({
    url: '/platform/article/detail',
    method: 'get',
    params: data
  })
}

// 新增平台文章
export function addArticle(data) {
  return request({
    url: '/platform/article/add',
    method: 'post',
    data: data
  })
}

// 修改平台文章
export function updateArticle(data) {
  return request({
    url: '/platform/article/edit',
    method: 'post',
    data: data
  })
}

// 删除平台文章
export function delArticle(data) {
  return request({
    url: '/platform/article/delete',
    method: 'post',
    data: data
  })
}
